import { HttpContextToken } from '@angular/common/http';

/** When true, `AuthInterceptor` uses session auth even on `/shared-report` routes. */
export const USE_SESSION_HTTP_AUTH = new HttpContextToken<boolean>((): boolean => false);
